export default "__VITE_ASSET__DkDxlRNL__"